import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './MainLayout.css';

const MainLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="main-layout">
      <header className="header">
        <div className="header-content">
          <h1 className="logo">Renew World</h1>
          
          <nav className="nav desktop-nav">
            <NavLink 
              to="/feed" 
              className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
            >
              피드
            </NavLink>
            <NavLink 
              to="/explore" 
              className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
            >
              탐색
            </NavLink>
            <NavLink 
              to="/upload" 
              className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
            >
              업로드
            </NavLink>
            {user?.role === 'ADMIN' && (
              <NavLink 
                to="/admin/trash" 
                className={({ isActive }) => isActive ? 'nav-link admin-link active' : 'nav-link admin-link'}
              >
                🗑️ 휴지통
              </NavLink>
            )}
          </nav>

          <div className="user-menu">
            <span className="username">{user?.username}</span>
            <button onClick={handleLogout} className="logout-btn">
              로그아웃
            </button>
          </div>
        </div>
      </header>

      <main className="main-content">
        <Outlet />
      </main>

      {/* 모바일 하단 네비게이션 */}
      <nav className="mobile-nav">
        <NavLink 
          to="/feed" 
          className={({ isActive }) => isActive ? 'mobile-nav-link active' : 'mobile-nav-link'}
        >
          <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <line x1="3" y1="9" x2="21" y2="9"/>
            <line x1="9" y1="21" x2="9" y2="9"/>
          </svg>
          <span className="nav-label">피드</span>
        </NavLink>
        <NavLink 
          to="/explore" 
          className={({ isActive }) => isActive ? 'mobile-nav-link active' : 'mobile-nav-link'}
        >
          <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/>
            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
          <span className="nav-label">탐색</span>
        </NavLink>
        <NavLink 
          to="/upload" 
          className={({ isActive }) => isActive ? 'mobile-nav-link active' : 'mobile-nav-link'}
        >
          <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <line x1="12" y1="8" x2="12" y2="16"/>
            <line x1="8" y1="12" x2="16" y2="12"/>
          </svg>
          <span className="nav-label">업로드</span>
        </NavLink>
        {user?.role === 'ADMIN' && (
          <NavLink 
            to="/admin/trash" 
            className={({ isActive }) => isActive ? 'mobile-nav-link admin-link active' : 'mobile-nav-link admin-link'}
          >
            <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="3 6 5 6 21 6"/>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
              <line x1="10" y1="11" x2="10" y2="17"/>
              <line x1="14" y1="11" x2="14" y2="17"/>
            </svg>
            <span className="nav-label">휴지통</span>
          </NavLink>
        )}
      </nav>
    </div>
  );
};

export default MainLayout;

